import React from 'react'
import ReactGA from 'react-ga'
import { isMobile } from 'react-device-detect'
import { Grid, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faWhatsappSquare,
  faFacebookSquare,
  faTwitterSquare,
} from '@fortawesome/free-brands-svg-icons'
import { withStyles } from '@material-ui/core'
import { styles } from '../styles/js/dialogShare'

const ShareIcons = ({
  classes,
  size,
  justify,
  color,
  photoParam,
  telespectador,
  mobileXs,
  pageProps,
}) => {
  return (
    <Grid container justifyContent={justify} className={classes.root}>
      <a
        href={`${
          isMobile ? 'whatsapp://' : 'https://web.whatsapp.com/'
        }send?text=${pageProps.shareMessage.replace(
          '{0}',
          telespectador.replace(/\s{2,}/g, ' ').trim()
        )}%0a${window.location.href}${photoParam ? photoParam : ''}`}
        target='_blank'
        rel='noopener noreferrer'
        onClick={event => {
          event.stopPropagation()
          ReactGA.event({
            category: `${pageProps.title}`,
            action: 'Share via WhatsApp',
          })
        }}
      >
        <Grid item>
          <FontAwesomeIcon
            icon={faWhatsappSquare}
            size={size}
            className={classes.icon + (mobileXs ? ' ' + classes.xsIcon : '')}
            style={{ color: color }}
          />
          <Typography
            className={
              classes.iconLabel + (mobileXs ? ' ' + classes.xsIconLabel : '')
            }
            style={{ color: color }}
            variant='h6'
          >
            WhatsApp
          </Typography>
        </Grid>
      </a>

      <a
        href={`https://www.facebook.com/sharer/sharer.php?&u=${
          window.location.href
        }${photoParam ? photoParam : ''}&quote=${pageProps.shareMessage.replace(
          '{0}',
          telespectador.replace(/\s{2,}/g, ' ').trim()
        )}`}
        target='_blank'
        rel='noopener noreferrer'
        onClick={event => {
          event.stopPropagation()
          ReactGA.event({
            category: `${pageProps.title}`,
            action: 'Share via Facebook',
          })
        }}
      >
        <Grid item>
          <FontAwesomeIcon
            icon={faFacebookSquare}
            size={size}
            className={classes.icon + (mobileXs ? ' ' + classes.xsIcon : '')}
            style={{ color: color }}
          />
          <Typography
            className={
              classes.iconLabel + (mobileXs ? ' ' + classes.xsIconLabel : '')
            }
            style={{ color: color }}
            variant='h6'
          >
            Facebook
          </Typography>
        </Grid>
      </a>

      <a
        href={`http://twitter.com/share?text=${pageProps.shareMessageTwitter.replace(
          '{0}',
          telespectador.replace(/\s{2,}/g, ' ').trim()
        )}&url=${window.location.href}${
          photoParam ? photoParam : ''
        }&hashtags=${pageProps.hashtag},RPC`}
        target='_blank'
        rel='noopener noreferrer'
        onClick={event => {
          event.stopPropagation()
          ReactGA.event({
            category: `${pageProps.title}`,
            action: 'Share via Twitter',
          })
        }}
      >
        <Grid item>
          <FontAwesomeIcon
            icon={faTwitterSquare}
            size={size}
            className={classes.icon + (mobileXs ? ' ' + classes.xsIcon : '')}
            style={{ color: color }}
          />
          <Typography
            className={
              classes.iconLabel + (mobileXs ? ' ' + classes.xsIconLabel : '')
            }
            style={{ color: color }}
            variant='h6'
          >
            Twitter
          </Typography>
        </Grid>
      </a>
    </Grid>
  )
}

export default withStyles(styles)(ShareIcons)
